import { create } from "zustand";

const defaultLayout = [
   { id: "grid-1", visualizationId: null, span: 12, order: 0, savedFilters: null },
   { id: "grid-2", visualizationId: null, span: 12, order: 1, savedFilters: null },
   { id: "grid-3", visualizationId: null, span: 12, order: 2, savedFilters: null },
   { id: "grid-4", visualizationId: null, span: 12, order: 3, savedFilters: null },
   { id: "grid-5", visualizationId: null, span: 12, order: 4, savedFilters: null },
   { id: "grid-6", visualizationId: null, span: 12, order: 5, savedFilters: null },
];

const defaultFilters = {
   round: undefined,
   organization: undefined,
   score: undefined,
   survey: undefined,
   manager: undefined
};

// const callDashboardEndpoint = (isActionPlan) => {
  
// }

export const useDashboardStore = create((set, get) => ({
   // Edit mode state
   isEditMode: false,
   setEditMode: (value) => set({ isEditMode: value }),
   toggleEditMode: () => set((state) => ({ isEditMode: !state.isEditMode })),

   filterOptions: {
      rounds: [],
      organizations: [],
      scores: [],
      surveys: [],
      managers: []
   },
   filterOptionsLoaded: {
      rounds: false,
      organizations: false,
      scores: false,
      surveys: false,
      managers: false
   },
   setFilterOptions: (key, values) => 
      set((state) => ({
         filterOptions: { ...state.filterOptions, [key]: values },
         filterOptionsLoaded: { ...state.filterOptionsLoaded, [key]: true }
      })),
   resetFilterOptionsLoaded: (keys = []) =>
      set((state) => ({
         filterOptionsLoaded: keys.reduce(
            (acc, key) => ({
               ...acc,
               [key]: false
            }),
            state.filterOptionsLoaded
         )
      })),
   // Filters
   filters: defaultFilters,
   setFilters: (filters) => set({ filters }),
   updateFilter: (key, value) =>
      set((state) => ({
         filters: { ...state.filters, [key]: value }
      })),
   clearFilters: () => set({ filters: defaultFilters }),

   // Dashboard layout (grid positions of visualizations)
   ResultsLayout: [...defaultLayout],
   ActionPlanLayout: [...defaultLayout],

   // setLayout: (layout) => set({ layout }),

   setResultsLayout: (layout) => set({ ResultsLayout: layout }),
   setActionPlanLayout: (layout) => set({ ActionPlanLayout: layout }),

   // Update a single grid cell with a new visualization
   updateGridCell: (gridId, visualizationId, isActionPlan) => {
      isActionPlan ?
      set((state) => ({
         ActionPlanLayout: state.ActionPlanLayout.map((item) =>
            item.id === gridId ? { ...item, visualizationId, savedFilters: null } : item
         )
      })) :
      set((state) => ({
         ResultsLayout: state.ResultsLayout.map((item) =>
            item.id === gridId ? { ...item, visualizationId, savedFilters: null } : item
         )
      }))

      // callDashboardEndpoint(isActionPlan);
   },

   // Remove visualization from a grid cell
   removeFromGrid: (gridId, isActionPlan) =>
      isActionPlan ?
      set((state) => ({
         ActionPlanLayout: state.ActionPlanLayout.map((item) =>
            item.id === gridId ? { ...item, visualizationId: null, savedFilters: null } : item
         )
      })) :
      set((state) => ({
         ResultsLayout: state.ResultsLayout.map((item) =>
            item.id === gridId ? { ...item, visualizationId: null, savedFilters: null } : item
         )
      })),
      // set((state) => ({
      //    layout: state.layout.map((item) =>
      //       item.id === gridId ? { ...item, visualizationId: null } : item
      //    )
      // })),

   // Remove an empty grid cell entirely from the layout
   removeLayoutSpot: (gridId, isActionPlan) =>
      isActionPlan ?
      set((state) => ({
         ActionPlanLayout: state.ActionPlanLayout.filter((item) => item.id !== gridId)
      })) :
      set((state) => ({
         ResultsLayout: state.ResultsLayout.filter((item) => item.id !== gridId)
      })),

   // Swap two visualizations between grid cells
   swapVisualizations: (sourceGridId, destGridId, isActionPlan) =>
      isActionPlan ?
      set((state) => {
         const sourceItem = state.ActionPlanLayout.find((item) => item.id === sourceGridId);
         const destItem = state.ActionPlanLayout.find((item) => item.id === destGridId);

         if (!sourceItem || !destItem) return state;

         return {
            ActionPlanLayout: state.ActionPlanLayout.map((item) => {
               if (item.id === sourceGridId) {
                  return {
                     ...item,
                     visualizationId: destItem.visualizationId,
                     savedFilters: destItem.savedFilters || null
                  };
               }
               if (item.id === destGridId) {
                  return {
                     ...item,
                     visualizationId: sourceItem.visualizationId,
                     savedFilters: sourceItem.savedFilters || null
                  };
               }
               return item;
            })
         };
      }) :
      set((state) => {
         const sourceItem = state.ResultsLayout.find((item) => item.id === sourceGridId);
         const destItem = state.ResultsLayout.find((item) => item.id === destGridId);

         if (!sourceItem || !destItem) return state;

         return {
            ResultsLayout: state.ResultsLayout.map((item) => {
               if (item.id === sourceGridId) {
                  return {
                     ...item,
                     visualizationId: destItem.visualizationId,
                     savedFilters: destItem.savedFilters || null
                  };
               }
               if (item.id === destGridId) {
                  return {
                     ...item,
                     visualizationId: sourceItem.visualizationId,
                     savedFilters: sourceItem.savedFilters || null
                  };
               }
               return item;
            })
         };
      }),

   // Reset layout to default
   resetLayout: (isActionPlan) => isActionPlan ? set({ ActionPlanLayout: defaultLayout }) : set({ ResultsLayout: defaultLayout }),

   // Loading state
   isLoading: false,
   setIsLoading: (value) => set({ isLoading: value }),

   // Selected assessment from sidebar
   selectedAssessment: null,
   setSelectedAssessment: (assessment) => set({ selectedAssessment: assessment }),

   // Linked self-assessment (expert role, "Compare with self assessment")
   linkedAssessment: null,
   setLinkedAssessment: (assessment) => set({ linkedAssessment: assessment })
}));
